import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { 
  Plus, 
  Search, 
  MessageSquare, 
  Target, 
  Calendar,
  BookOpen,
  Briefcase,
  Tag,
  Gift,
  GraduationCap,
  Lightbulb,
  Users
} from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const QuickActions = () => {
  const navigate = useNavigate();

  const primaryActions = [
    {
      title: "Messages",
      description: "Envoyer un message direct",
      icon: MessageSquare,
      action: () => navigate('/networking?tab=hub'),
      color: "text-green-600",
      bgColor: "bg-green-50"
    },
    {
      title: "Annuaire",
      description: "Rechercher un membre",
      icon: Search,
      action: () => navigate('/members'),
      color: "text-purple-600",
      bgColor: "bg-purple-50"
    },
    {
      title: "Créer un Insight",
      description: "Partager vos analyses",
      icon: Plus,
      action: () => navigate('/insights'),
      color: "text-blue-600",
      bgColor: "bg-blue-50"
    },
  ];

  const exploreActions = [
    { title: "Événements", icon: Calendar, path: "/events" },
    { title: "Workshops", icon: GraduationCap, path: "/workshops" },
    { title: "Job Board", icon: Briefcase, path: "/jobs" },
    { title: "Deals", icon: Tag, path: "/deals" },
    { title: "Avantages", icon: Gift, path: "/perks" },
    { title: "Commissions", icon: Users, path: "/commissions" },
  ];

  return (
    <div className="space-y-6">
      {/* Actions principales */}
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Target className="h-5 w-5 text-primary" />
            Actions Rapides
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-3">
          {primaryActions.map((action, index) => (
            <Button
              key={index}
              variant="outline"
              className="w-full justify-start h-auto p-3 sm:p-4 hover:bg-accent/50"
              onClick={action.action}
            >
              <div className={`p-1.5 sm:p-2 rounded-lg ${action.bgColor} mr-2 sm:mr-3`}>
                <action.icon className={`h-3 w-3 sm:h-4 sm:w-4 ${action.color}`} />
              </div>
              <div className="text-left">
                <div className="font-medium text-xs sm:text-sm">{action.title}</div>
                <div className="text-[10px] sm:text-xs text-muted-foreground">{action.description}</div>
              </div>
            </Button>
          ))}
        </CardContent>
      </Card>

      {/* Explorer — accès centralisé à toutes les fonctionnalités */}
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Lightbulb className="h-5 w-5 text-primary" />
            Explorer
          </CardTitle>
          <p className="text-sm text-muted-foreground">
            Toutes les ressources du réseau
          </p>
        </CardHeader>
        <CardContent>
          <div className="grid grid-cols-2 gap-2">
            {exploreActions.map((item) => (
              <Button
                key={item.path}
                variant="ghost"
                size="sm"
                className="justify-start h-auto py-2.5 px-3 hover:bg-accent/50"
                onClick={() => navigate(item.path)}
              >
                <item.icon className="h-4 w-4 mr-2 text-muted-foreground" />
                <span className="text-xs font-medium">{item.title}</span>
              </Button>
            ))}
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default QuickActions;
